<template>
  <div class="flexChart">
    <div class="chartContent">
      <div class="content">Anteil der letzten 30 Tage</div>
      <div class="content color3 content_sans">Ziel 2030: 80&nbsp;% im Jahr</div>
    </div>
    <div class="chartContainer" ref="chartContainer">
      <div ref="chart" class="lineChart"></div>
      <div class="tooltip tooltip2"></div>
    </div>
  </div>
</template>

<script>
import { store } from "../store";
import * as d3 from "d3";
import _ from "lodash";

export default {
  data() {
    return {
      store,
    };
  },
  components: {},
  props: {
    dataElecMonth: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleResize: _.debounce(function () {
      this.windowWidth = window.innerWidth;
      const chartParent = this.$refs.chart;
      const svgNode = chartParent.querySelector("svg");
      chartParent.removeChild(svgNode);
      this.drawChart(this.$refs.chartContainer.clientWidth);
    }, 200),
    drawChart(containerWidth) {
      const chartWidth = containerWidth;
      //console.log("drawChart elecMonth", console.log(JSON.stringify(this.dataElecMonth)));

      const data = this.dataElecMonth;

      const margin = { top: 0, right: 0, bottom: 16, left: 17 };
      const width = chartWidth - margin.left - margin.right;
      const height = 96 - margin.top - margin.bottom;

      //set minimum value of the maximum value of the chart
      const minMax = 85;

      // Set the width of the left axis
      const yAxisWidth = 17;
      const xAxisHeight = 16;

      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      const x = d3
        .scaleBand()
        .domain(data.map((d) => d[1].toString()))
        .range([0, width])
        .padding(0.3);

      const xAxis = d3.axisBottom(x);
      xAxis
        .tickValues([data[0][1], data[data.length - 1][1]])
        .tickSize(0)
        .tickSizeInner(0);

      svg
        .append("g")
        .attr("transform", `translate(${margin.left}, ${height + 2})`)
        .attr("width", `${width})`)
        .classed("axis-label", true);

      const leftLabel = svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", 0)
        .attr("y", height + margin.bottom - 4)
        .attr("text-anchor", "start")
        .attr("fill", "var(--mm-grey-400)")
        .text(data[0][1]);

      const rightLabel = svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", width)
        .attr("y", height + margin.bottom - 4)
        .attr("text-anchor", "end")
        .attr("fill", "var(--mm-grey-400)")
        .text(data[data.length - 1][1]);

      const y = d3
        .scaleLinear()
        .range([height, 0])
        .domain([0, d3.max(data, (d) => d[0]) < minMax ? minMax : d3.max(data, (d) => d[0])])
        .nice();

      const yAxis = d3.axisLeft(y).tickValues([0, 50, 80]).tickPadding(4).tickSize(0).tickSizeInner(-width);

      svg.append("g").call(yAxis).attr("class", "y-axis").classed("axis-label", true);

      const bar = svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("x", (d) => x(d[1].toString()))
        .attr("width", x.bandwidth())
        // .attr("y", (d) => height)
        // .attr("height", (d) => 0)
        .attr("y", (d) => y(d[0].toString()))
        .attr("height", (d) => height - y(d[0].toString()))
        .attr("fill", "var(--mm-green-color)")
        .attr("title", (d) => d[0]) // set the title attribute
        .attr("class", "mask")
        .style("cursor", "pointer")
        .on("mouseover", () => {})
        .on("touchmove mousemove", (event, d) => {
          const containerOffset = bar.node().getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const tooltip = d3.select(".tooltip2");
          tooltip.transition().duration(200).style("opacity", 0.9);
          tooltip
            .html(d[1].toString() + "</br><b>" + d[0].toString().replace(".", ",") + "&nbsp;%</b>")
            .style("left", function () {
              const svgOffset = svg.node().getBoundingClientRect();
              const current_position = event.pageX - containerOffset.left;
              if (current_position + 63 > svgOffset.width) {
                return svgOffset.width - 63 + "px";
              } else {
                return current_position + "px";
              }
            })
            .style("top", height / 2 + "px")
            .style("cursor", "pointer");
          // .style("left", d3.mouse(this)[0] + 70 + "px")
          // .style("top", d3.mouse(this)[1] + "px");
        })
        .on("mouseout", () => {
          d3.select(".tooltip2").transition().duration(500).style("opacity", 0);
        });
      // .transition()  // remove animation
      // .delay((d, i) => 180 + i * 10)
      // .duration(500)
      // .attr("y", (d) => y(d[0].toString()))
      // .attr("height", (d) => height - y(d[0].toString()));
    },
  },
  watch: {
    dataElecMonth() {
      let chartWidth = this.$refs.chartContainer.clientWidth;
      this.drawChart(chartWidth);
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
